import { hypernova, gem } from './src/icons'

export { gem as gemIcons }

export type IconSet = Record<string, React.VFC<React.SVGProps<SVGSVGElement>>>
export type IconSystem = 'gem' | 'hypernova'

export type GemIconName = keyof typeof gem
export const gemIconNames = Object.fromEntries(
  Object.keys(gem).map((key) => [key, key])
) as Record<GemIconName, GemIconName>

export function isGemIconName(name: string): name is GemIconName {
  return Object.keys(gem).includes(name)
}

export type HypernovaIconName = keyof typeof hypernova
export const hypernovaIconNames = Object.fromEntries(
  Object.keys(hypernova).map((key) => [key, key])
) as Record<HypernovaIconName, HypernovaIconName>

export const allIconNames = {
  ...gemIconNames,
  ...hypernovaIconNames,
}

export const icons: Record<IconSystem, IconSet> = {
  hypernova,
  /** @note Prefer importing `gemIcons`; `icons.gem` prevents tree-shaking */
  gem,
}

/**
 * For icons with multiple strokes or fill areas, we use this pink color
 * in our design systems to indicate that an icon's color can be changed.
 * By matching on this color code and applying "currentColor", we can be
 * explicit about which portions of an icons should be colorable.
 */
export const FUNGIBLE_COLOR = '#FF3CA0'
